import { IRiskProcessEditItem, RiskProcessEditItem } from "./riskProcessEditItem";

export interface IRiskProcessEdit {
    item: IRiskProcessEditItem;
}

export class RiskProcessEdit implements IRiskProcessEdit {
    item: RiskProcessEditItem;

    constructor();
    constructor(obj: IRiskProcessEdit);
    constructor(obj?: any) {
        this.item = new RiskProcessEditItem(obj ? obj.item : null);
    }
}